import { render } from "./uploadFileTitle.vue?vue&type=template&id=453bec1b&scoped=true"
const script = {}

import "./uploadFileTitle.vue?vue&type=style&index=0&id=453bec1b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453bec1b"]])

export default __exports__